import { Chart } from "./ReactGoogleCharts";

export * from "./types";
export { Chart };
export default Chart;
